import { useTranslation } from 'react-i18next';
import translations from './newsTranslations.json';
import { getAllNewsSorted, getNewsBySlug } from './news';

const MONTHS_NO = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
const LOCALE = { en: 'en-GB', so: 'so-SO', ar: 'ar', fr: 'fr-FR', es: 'es-ES' };

// "28. august 2026" -> localized long date
const localizeDate = (dateStr, lang) => {
  const m = /^(\d{1,2})\.\s+([a-zæøå]+)\s+(\d{4})$/i.exec(dateStr || '');
  const month = m ? MONTHS_NO.indexOf(m[2].toLowerCase()) : -1;
  if (!m || month < 0) return dateStr;
  try {
    return new Date(Number(m[3]), month, Number(m[1])).toLocaleDateString(LOCALE[lang] || 'nb-NO', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return dateStr;
  }
};

export const localizeArticle = (article, lang) => {
  if (!article) return article;
  const l = (lang || 'no').split('-')[0];
  if (l === 'no') return article;
  const tr = translations[String(article.id)]?.[l];
  const { aux, ...fields } = tr || {};
  return { ...article, ...fields, ...(aux || {}), date: localizeDate(article.date, l), isTranslated: Boolean(tr) };
};

export const useLocalizedNews = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return {
    lang,
    all: () => getAllNewsSorted().map((a) => localizeArticle(a, lang)),
    latest: (n = 3) => getAllNewsSorted().slice(0, n).map((a) => localizeArticle(a, lang)),
    bySlug: (slug) => localizeArticle(getNewsBySlug(slug), lang),
  };
};
